const WIDGET_ROOT = 'widgetRoot';
const WIDGET_BUTTON_ID = 'horn-widget-button';
const WIDGET_WRAPPER_ID = 'horn-widget-wrapper';
const WIDGET_OWNER_ID_ATTRIBUTE = 'data-horn-business-owner-id';
const WIDGET_ACTIVITY_ID_ATTRIBUTE = 'data-horn-activity-id';
const WIDGET_ACCOMMODATION_ID_ATTRIBUTE = 'data-horn-accommodation-id';
const WIDGET_RENTAL_ID_ATTRIBUTE = 'data-horn-rental-id';
const WIDGET_COLOR_ATTRIBUTE = 'data-horn-color';
const WIDGET_GOOGLE_ANALYTICS_ID_ATTRIBUTE = 'data-horn-google-analytics-id';
const WIDGET_LANGUAGES_ATTRIBUTE = 'data-horn-languages';
const WIDGET_LOGO_ATTRIBUTE = 'data-horn-logo';
const WIDGET_PRIVACY_POLICY_ATTRIBUTE = 'data-horn-privacy-policy';
const WIDGET_TERMS_AND_CONDITIONS_ATTRIBUTE = 'data-horn-terms-and-conditions';
const WIDGET_CLICK_HANDLER = `(function(){document.getElementById('${WIDGET_WRAPPER_ID}').contentWindow.mountApp(event)})()`;

const MENU = [
  {
    title: 'Date and Guests'
  },
  {
    title: 'Add-ons | optional'
  },
  {
    title: 'Activities | optional'
  },
  {
    title: 'Checkout'
  },
  {
    title: 'Payment'
  }
];

const MENU_RENTAL = [
  {
    title: 'Date and units'
  },
  {
    title: 'Add-ons | optional'
  },
  {
    title: '1stCheckout'
  },
  {
    title: 'Checkout'
  },
  {
    title: 'Payment'
  }
];

const FOOTER_MENU = [
  {
    title: 'Date and Guests'
  },
  {
    title: 'Add-ons'
  },
  {
    title: 'Activities'
  },
  {
    title: 'Checkout'
  },
  {
    title: 'Payment'
  }
];

const ACCOMMODATION_TITLE = 'Accommodation';
const ACTIVITY_TITLE = 'Activity';
const RENTAL_ITEM_TITLE ='Rental Item';

const PRODUCTS_MENU = [
  {
    title: ACCOMMODATION_TITLE
  },
  {
    title: ACTIVITY_TITLE
  },
  {
    title: RENTAL_ITEM_TITLE
  }
];

const STRIPE = 'Credit & Debit cards';
const PAYPAL = 'Pay with Paypal';
const PAY_ON_ARRIVAL = 'Pay on arrival';

const ADD_ONS_INDEX = 1;
const RELATED_PRODUCTS_INDEX = 2;

export {
  WIDGET_ROOT,
  WIDGET_BUTTON_ID,
  WIDGET_WRAPPER_ID,
  WIDGET_OWNER_ID_ATTRIBUTE,
  WIDGET_ACTIVITY_ID_ATTRIBUTE,
  WIDGET_ACCOMMODATION_ID_ATTRIBUTE,
  WIDGET_RENTAL_ID_ATTRIBUTE,
  WIDGET_COLOR_ATTRIBUTE,
  WIDGET_GOOGLE_ANALYTICS_ID_ATTRIBUTE,
  WIDGET_LANGUAGES_ATTRIBUTE,
  WIDGET_LOGO_ATTRIBUTE,
  MENU,
  MENU_RENTAL,
  FOOTER_MENU,
  ACCOMMODATION_TITLE,
  ACTIVITY_TITLE,
  RENTAL_ITEM_TITLE,
  PRODUCTS_MENU,
  STRIPE,
  PAYPAL,
  PAY_ON_ARRIVAL,
  ADD_ONS_INDEX,
  RELATED_PRODUCTS_INDEX,
  WIDGET_PRIVACY_POLICY_ATTRIBUTE,
  WIDGET_TERMS_AND_CONDITIONS_ATTRIBUTE,
  WIDGET_CLICK_HANDLER
};
